import { Component, Input, ElementRef, ViewChild, HostBinding, Output, EventEmitter } from "@angular/core";
import { IBpTooltipPosition } from "@modules/core/directives/bp-tooltip/bp-tooltip.interface";

@Component({
	selector: "bp-tile",
	templateUrl: "./bp-tile.component.html",
	styleUrls: ["./bp-tile.component.scss"],
	standalone: false
})
export class BpTileComponent {
	@Input()
	public css: string = "";

	@Input()
	public padding: boolean = true;

	@Input()
	public isHistory: boolean = false;

	@Input()
	public isWalletDetails: boolean = false;

	@Input("title")
	public title: string;

	@Input()
	public titleAddition: string = "";

	@Input("tile-tooltip")
	public tooltip: string;

	@Input("tooltip-link")
	public link: string = "";

	@Input("showHeader")
	public showHeader: boolean = true;

	@Input("headerExtraInfo")
	public headerExtraInfo: string = "";

	@Input()
	@HostBinding("attr.color")
	public color: "default" | "inverse" | "dark" = "default";

	@Input()
	public isHidePortfolioActive: boolean = true;

	@ViewChild("actionsRef", { read: ElementRef, static: true })
	public actionsRef: ElementRef;

	@Input()
	public placement: IBpTooltipPosition = "right";

	@Output()
	public headerClickEvent: EventEmitter<void> = new EventEmitter<void>();

	@Input()
	public isHeaderClickable: boolean = false;

	public constructor(public elementRef: ElementRef) {}

	public showTileHeader(): boolean {
		return (
			(this.actionsRef.nativeElement.children.length > 0 || (this.title && this.title.trim().length > 0)) &&
			this.showHeader
		);
	}

	public headerClickHandler(): void {
		if (this.isHeaderClickable) {
			this.headerClickEvent.emit();
		}
	}
}
